import { render, staticRenderFns } from "./HoverMetadataComponent.vue?vue&type=template&id=07d1d7ee&scoped=true"
import script from "./HoverMetadataComponent.vue?vue&type=script&lang=js"
export * from "./HoverMetadataComponent.vue?vue&type=script&lang=js"
import style0 from "./HoverMetadataComponent.vue?vue&type=style&index=0&id=07d1d7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1d7ee",
  null
  
)

export default component.exports